import { PRODUCT_TEST_DOCUMENT_TYPES } from "../constants"

import { useGetFileUploadData } from "@/components/upload/hooks/useGetFileUploadData"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { ReferenceTableName } from "@/graphql/codegen/graphql"

interface UseGetProductTestDocumentsReturn {
  documents: SignedUrl[]
  isFetching: boolean
  refetch: (immediate?: boolean) => void
}

export const useGetProductTestDocuments = (productTestId?: string): UseGetProductTestDocumentsReturn => {
  const { fileList, fileFetching, refetchFileUploadData } = useGetFileUploadData({
    referenceId: productTestId,
    fieldGroups: PRODUCT_TEST_DOCUMENT_TYPES,
    referenceTableName: ReferenceTableName.ProductTestDocument,
    pause: !productTestId,
  })

  return {
    documents: fileList,
    isFetching: fileFetching,
    refetch: refetchFileUploadData,
  }
}
